import React from "react";

const Topbar = ({ toggleSidebar, isSidebarOpen }) => {
  return (
    <nav className="navbar navbar-light bg-light border-bottom px-3 d-flex justify-content-between align-items-center">
      <button className="btn btn-outline-primary" onClick={toggleSidebar}>
        {isSidebarOpen ? "Hide Menu" : "Show Menu"}
      </button>
      <form className="d-flex">
        <input
          className="form-control me-2"
          type="search"
          placeholder="Search"
          aria-label="Search"
        />
        <button className="btn btn-outline-success" type="submit">
          Search
        </button>
      </form>
    </nav>
  );
};

export default Topbar;
